import {
  splitInsertImageMarkdownSegments,
  resolveInsertImageItems,
  InsertImageDocumentLookupParams,
  DownloadDocumentImageParams,
} from "@/utility/insertImageInstructions";
import { replaceMissingDataTokens } from "@/utility/prepareGeneratedContentPreview";
import { replaceTaskItemTokens } from "@/utility/taskItem";

export interface PrepareSectionContentForInsertionOptions {
  markdown: string;
  parseMarkdownSections: (markdown: string) => any[];
  projectId?: string;
  imageAssets?: any[];
  retrieveDocumentsForImageInsertion: (params: InsertImageDocumentLookupParams) => Promise<any>;
  retrieveDocumentImages: (documentId: string) => Promise<any>;
  downloadDocumentImage: (params: DownloadDocumentImageParams) => Promise<string>;
}

export const prepareSectionContentForInsertion = async ({
  markdown,
  parseMarkdownSections,
  projectId,
  imageAssets,
  retrieveDocumentsForImageInsertion,
  retrieveDocumentImages,
  downloadDocumentImage,
}: PrepareSectionContentForInsertionOptions) => {
  const normalizedMarkdown = replaceTaskItemTokens(replaceMissingDataTokens(markdown || ""), "markers");
  const segments = splitInsertImageMarkdownSegments(normalizedMarkdown);
  const insertionItems: any[] = [];

  for (const segment of segments) {
    if (segment.type === "markdown") {
      insertionItems.push(...parseMarkdownSections(segment.content || ""));
      continue;
    }

    if (segment.type === "image") {
      insertionItems.push(segment);
    }
  }

  return resolveInsertImageItems(insertionItems, {
    projectId,
    imageAssets,
    retrieveDocumentsForImageInsertion,
    retrieveDocumentImages,
    downloadDocumentImage,
  });
};
